import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  Input,
  forwardRef,
  OnChanges,
} from '@angular/core';
import {
  UntypedFormGroup,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  UntypedFormControl,
} from '@angular/forms';
import { FieldConfig, FieldType } from '../field.interface';
@Component({
  selector: 'app-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  template: `
    <ng-container *ngIf="field">
      <input
        *ngIf="field.inputType == 'hidden'"
        maxlength="4" type="{{field.inputType}}">

      <mat-form-field
        *ngIf="field.inputType != 'hidden'"
        [formGroup]="group"
        appearance="outline"
        class="demo-full-width"
      >
        <mat-label>{{ field.label }}
          <!-- <span *ngIf="field.inputType == 'number'">
            <b>({{ amount | replace:',':'' | number }})</b>
          </span> -->
        </mat-label>
        <span *ngIf="field?.inputPrefix" matPrefix>{{field?.inputPrefix}}</span>
        <input
          (input)="fieldChange($event)"
          [formControlName]="field.key || null"
          [mask]="field?.mask"
          [maxLength]="field.maxLength || 10000"
          [placeholder]="field.placeholder || field.label || ''"
          [readonly]="field.readonly"
          [required]="field.key && group?.get(field.key).errors !== null"
          [showMaskTyped]="field?.showInputMask"
          [type]="field.inputType == 'number'? 'text': (field.inputType || 'text')"
          matInput/>
        <mat-hint [ngClass]="{ danger: field.hintDanger }" align="start">{{ field.hint }}</mat-hint>
        <mat-hint *ngIf="field?.showCounter && field.key" align="end">{{ group?.get(field.key)?.value?.length || 0 }}
          / {{ field?.maxLength }}
        </mat-hint>
        <mat-icon *ngIf="field?.icon" matPrefix>{{ field?.icon }}</mat-icon>
        <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
          <mat-error
            *ngIf="field.key && group?.get(field.key)?.hasError(validation.name)">{{ validation.message }}
          </mat-error>
        </ng-container>
      </mat-form-field>
    </ng-container>
  `,
  // host: {'class': 'col-md-6'},
  styles: ['.danger { color:red }'],
})
export class InputComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() field!: FieldConfig;
  @Input() group: UntypedFormGroup = new UntypedFormGroup({});
  @Output() fieldValue = new EventEmitter();
  value: any;
  disabled = false;
  onChange: any = () => { };
  onTouched: any = () => { };

  settingValue($event: any): void {
    this.value = $event;
    // if(this.field.key){
    //   this.group.controls[this.field.key].setValue(this.value)
    // }
    this.onChange(this.value);
  }

  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() { }
  writeValue(value: any): void {
    if (value !== undefined) {
      this.fieldChange(value);
    }
  }



  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  ngOnInit() {
    //
    this.group.addControl(
      this.field?.key || 'id',
      new UntypedFormControl('', [])
    );
    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }

  ngOnChanges() {

    if (this.field?.disabled) {
      this.group.controls[this.field.key as string].disable();
    }
  }

  fieldChange(v: any = null) {
    let value = v?.target?.value;
    // if (this.field.inputType == 'number') {
    //   value = parseFloat(value.replace(/,/g, ''));
    // }
    // if (this.field.key) this.group.controls[this.field.key].setValue(value);
    this.settingValue(value);
    let formatedValue = value;
    if (this.field.type == FieldType.input && this.field.inputType == 'number') {
      formatedValue = parseFloat(value?.replace(/,/g, ''));
    }
    this.fieldValue.emit({ value: formatedValue, field: this.field, object: {} });
  }
}
